// Generated by purs version 0.15.16
var unsecond = function (dict) {
    return dict.unsecond;
};
var unfirst = function (dict) {
    return dict.unfirst;
};
export {
    unfirst,
    unsecond
};
//# sourceMappingURL=index.js.map
